module.exports = __webpack_public_path__ + "img/carMiddle.e175a906.png";